import React, { useState } from 'react'

import { withRouter } from "react-router-dom";
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    LinearProgress,
    withStyles,
    Typography,
} from "@material-ui/core";

import { useDispatch } from 'react-redux';

import { withTranslation } from 'react-i18next';
import { useAxiosClient } from '../../../../contexts/Axios';
import { AddBPMApplicationMessages } from '../../../../redux/reducers/BPMReducer';

const ColorLinearProgress = withStyles({
  colorPrimary: {
    backgroundColor: '#a7cbc7',
  },
  barColorPrimary: {
    backgroundColor: '#075e54',
  },
})(LinearProgress);

const CMFileUploadDialog = props => {
    const [ file, setFile ] = useState(null);
    const [ isLoading, setLoading ] = useState(false);
    const [ progress, setProgress ] = useState(0);

    const { open, handleClose, t } = props;
    const { axiosClient } = useAxiosClient()

    const dispatch = useDispatch()

    const onSelectFile = e => {
        setFile(e.target.files[0]);
    };

    const createApplicationMessage = (text, variant, clckRedirect) => {
        dispatch(AddBPMApplicationMessages({
            text: text, 
            duration: 8000,
            variant: variant,
            clckRedirect: clckRedirect,
        }))
    }

    const onClose = () => {
        setFile(null);
        setLoading(false);
        setProgress(0);
        handleClose();
    };

    const onClickUpload = () => {
        setLoading(true)
        const config = {
            onUploadProgress: (progressEvent) => {
                setProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total));
        }};
        const data = new FormData();
        data.append('file', file);
        axiosClient.post(
            `/cm/upload/`,
            data,
            config
        ).then(
            response => {
                createApplicationMessage(t('massiveUpload:File Uploaded. Refreshing Table...'), 'success')
                setTimeout(() => {
                    onClose();
                }, 4000);
            }
        ).catch(
            error => {
                setLoading(false)
                setProgress(0)
                createApplicationMessage(t('massiveUpload:File Upload Failed'), 'error')
            }
        )
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >

                <DialogTitle id="alert-dialog-title" >
                    {'Integration ' + t('massiveUpload:Upload File')}
                </DialogTitle>

                <DialogContent>
                    <DialogContentText>
                    {t('massiveUpload:Upload File')}
                    <input type="file" name="file" onChange={onSelectFile}/>
                    </DialogContentText>
                    <div style={{height:30}}>
                    {
                    isLoading &&
                        <div style={{paddingTop: 15}}>
                        {
                            progress !== 0 ?
                            <div>
                                <ColorLinearProgress style={{marginBottom:5}} variant="determinate" value={progress} />
                                <Typography style={{textAlign:'center'}}>
                                    {`${progress}%`}
                                </Typography>
                            </div>
                            :
                                <ColorLinearProgress style={{marginBottom:5}} variant="query" />
                        }
                        </div>
                    }
                    </div>
                </DialogContent>

                <DialogActions>
                    <Button
                        key="dab_02"
                        onClick={handleClose}
                        variant="contained"
                    >
                        {t('massiveUpload:Cancel')}
                    </Button>

                    <Button
                        key="dab_03"
                        disabled={isLoading || !file}
                        onClick={onClickUpload}
                        variant="contained"
                        color="secondary"
                        autoFocus
                    >
                        {t('massiveUpload:Upload')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
};

export default withTranslation()(withRouter(CMFileUploadDialog));
